import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/authSlice';
import { CircularProgress, Box, Typography } from '@mui/material';

const LogoutCallback: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleLogoutCallback = async () => {
      console.log('🚪 Processing logout callback...');
      
      // Clear any remaining Redux state
      dispatch(logout());
      
      // Clear all auth-related storage
      const keysToRemove: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && (key.startsWith('oidc.') || key.includes('token') || key.includes('user'))) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach(key => localStorage.removeItem(key));
      
      // Clear session storage
      sessionStorage.clear();
      
      console.log('✅ Logout complete, redirecting to login...');
      
      // Redirect to login page after a short delay
      setTimeout(() => {
        navigate('/login', { replace: true });
      }, 500);
    };

    handleLogoutCallback();
  }, [dispatch, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={2}
    >
      <CircularProgress />
      <Typography variant="h6">Logging out...</Typography>
    </Box>
  );
};

export default LogoutCallback;